exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".datepicker {\n  color: black;\n  border: 1px solid silver;\n}\n\n.btn-link:disabled {\n  color: gray !important;\n}", ""]);

